import { useQuery } from 'react-query';
import { network } from 'services/network';
import {
    IGateForMapping,
    IMappingData,
    IMilestones,
} from 'components/Dashboards/Portfolio/phasePerformance/manage/manage.types';
import { QueryStateValue } from 'hooks/useQueryState';

const getSingleTemplate = (templateId) => {
    return network
        .post('api/bo/phaseperformance/getTemplate', { template_id: templateId })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const getMilestones = (contractId) => {
    return network
        .post('api/bo/phaseperformance/getMilestones', { contract_id: contractId })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const getMapping = (params: IGetMappingPayload) => {
    delete params.contractUuid;

    return network
        .post('api/bo/phaseperformance/getMapping', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const useQueryGetSingleTemplate = (templateId: QueryStateValue, contractId?: QueryStateValue) => {
    return useQuery<IGateForMapping, QueryError>(
        ['phasePerformanceSingleTemplate', templateId],
        () => getSingleTemplate(templateId),
        {
            enabled: Boolean(templateId) && !Boolean(contractId),
            cacheTime: 0,
        },
    );
};

const useQueryGetMilestones = (contractId) => {
    return useQuery<IMilestones[], QueryError>(
        ['phasePerformanceMilestones', contractId],
        () => getMilestones(contractId),
        {
            enabled: Boolean(contractId),
        },
    );
};

interface IGetMappingPayload {
    template_id: QueryStateValue;
    contract_id: number | undefined;
    contractUuid?: string | null;
    phase_template_id: QueryStateValue;
}

const useQueryGetMapping = (params: IGetMappingPayload) => {
    return useQuery<IMappingData, QueryError>(['phasePerformanceMapping', params], () => getMapping(params), {
        enabled:
            Boolean(params.template_id) &&
            Boolean(params.contract_id) &&
            Boolean(params.contractUuid) &&
            Boolean(params.phase_template_id),
        cacheTime: 0,
    });
};

export { useQueryGetSingleTemplate, useQueryGetMilestones, useQueryGetMapping };
